export default __webpack_public_path__ + "static/law-8b56f49a239bc8f576e2a759736c83e4.svg";